import React from 'react'
import { Row, Col, Image } from "antd";
import { Link } from 'react-router-dom';
import MonogramIcon from "assets/images/mongram.jpg";
import { baseImageURL } from 'utils/env';
import { useGlobalMerchant } from 'utils/helper';

const ECSProductComponent = ({
  filterProductList,
  handleCartAction,
  addedToCart,
}: any) => {
  const LinkAny: any = Link;
  const { ecommerceContent, globalMerchantCurrency, setProductContent } = useGlobalMerchant();
  return (
    <Row gutter={{ xs: 20, sm: 20, md: 35, lg: 35 }} >
      {filterProductList && filterProductList.map((product: any) => (
        <Col key={product.product_id} xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 8 }}>
          <div className="pCard mb50">
            <div className="pCardHeader dFlex alignCenter justifyCenter">
              <Image
                src={product.img !== null ? `${baseImageURL}${product.img}` : MonogramIcon}
                alt="product image"
              />
              <div className={product.qty <= 0 ? "disable stock" : "stock"}>
                {product.qty <= 0 ? <p className='disable sSmText'>Sold out</p> : <p className='sSmText'>In stock</p>}
              </div>
            </div>
            <div className="pCardBody mt30">
              <LinkAny className="pCardTitle sSmText mb5" to={`${ecommerceContent.merchant_pathway}/${product.product_name}`} onClick={() => setProductContent(product)}>
                {product.product_name}
              </LinkAny>
              <p className="pCardAmount sMdText mb5">{product.price} {globalMerchantCurrency}</p>
            </div>
            <div className="pCardFooter dFlex alignCenter justifyBetween ">
              <p className='sNmText fontMedium'>-33% Discount for SuiFrens Holders</p>
            </div>
          </div>
        </Col>
      ))}
    </Row>
  )
}

export default ECSProductComponent